import { render, staticRenderFns } from "./DetailEditLayout.vue?vue&type=template&id=35ad93c0&"
import script from "./DetailEditLayout.vue?vue&type=script&lang=js&"
export * from "./DetailEditLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports